import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { useAnalytics } from './useAnalytics';
import { getIsInDotCom } from '../Header/ducks/selectors';

const MenuButtonWrapper = styled.a`
  align-items: center;
  color: ${props => props.theme.carvana.blue.dark};
  display: inline-flex;
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 14px;
  font-weight: 700;
  justify-content: center;
  text-decoration: none;
  text-transform: uppercase;
  white-space: nowrap;
  letter-spacing: 0.34px;
  cursor: pointer;
  touch-action: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);

  &:focus {
    text-decoration: none;
  }

  &:hover {
    color: ${props => props.theme.carvana.blue.primary};
    text-decoration: none;
  }
`;

const MenuButton = ({
  children,
  className,
  dataCvTest,
  eventName,
  eventData,
  href,
  target,
  onClick,
  onTouchStart,
  disableHref,
  isInDotCom
}) => {
  const { trackEvent } = useAnalytics();
  const dotComTarget = isInDotCom ? '_self' : null;
  const nextTarget = target || dotComTarget;

  const handleClick = e => {
    if (eventName) {
      trackEvent(eventName, eventData);
    }
    onClick(e);

    const shouldPreventDefault = href === '' || disableHref;
    if (shouldPreventDefault) {
      e.preventDefault();
    }
  };

  const handleTouchStart = e => {
    onTouchStart(e);

    const shouldPreventDefault = href === '' || disableHref;
    if (shouldPreventDefault) {
      e.preventDefault();
    }
  };

  return (
    <MenuButtonWrapper
      role="menuitem"
      className={className}
      data-cv-test={dataCvTest}
      eventName={eventName}
      href={href}
      {...(nextTarget && { target: nextTarget })}
      onClick={e => handleClick(e, href, onClick, eventName, disableHref)}
      onTouchStart={e => handleTouchStart(e, href, onTouchStart, disableHref)}
    >
      {children}
    </MenuButtonWrapper>
  );
};

MenuButton.defaultProps = {
  className: '',
  dataCvTest: '',
  eventName: '',
  eventData: {},
  href: '',
  target: null,
  onClick: () => null,
  onTouchStart: () => null,
  disableHref: false
};

MenuButton.propTypes = {
  children: PropTypes.node.isRequired,
  isInDotCom: PropTypes.bool.isRequired,
  className: PropTypes.string,
  dataCvTest: PropTypes.string,
  eventName: PropTypes.string,
  eventData: PropTypes.shape({}),
  href: PropTypes.string,
  target: PropTypes.string,
  onClick: PropTypes.func,
  onTouchStart: PropTypes.func,
  disableHref: PropTypes.bool
};

const mapStateToProps = state => ({
  isInDotCom: getIsInDotCom(state)
});

export default connect(mapStateToProps)(MenuButton);
